import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';
import { tabletBreakpoint, desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { TitleComponent } from '@/src/views/ReimagineRemote/SubheroWithForm';

export const Section = styled.section`
  ${fluidProp('padding-top', '70px', '166px')}
  ${fluidProp('padding-bottom', '40px', '100px')}
  overflow: hidden;
  position: relative;
  background-color: #f4f8fe;
`;

export const Title = styled(TitleComponent)`
  max-width: 590px;
  color: var(--colors-darkBlue);
  ${({ theme }) => theme.typography.scale4}
  padding-bottom: 30px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  color: var(--colors-lynch);
  ${({ theme }) => theme.typography.bodyLead}

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  right: -5%;
  top: 10%;

  ${desktopBreakpoint(css`
    max-width: 50%;
  `)}

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  ${tabletBreakpoint(css`
    width: 100%;
  `)}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 200px;

  ${tabletBreakpoint(css`
    padding-bottom: 0;
  `)}
`;

export function InvoiceSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, illustration } = primary;

  return (
    <Section>
      <ContentContainer>
        <Wrapper>
          <ContentWrapper>
            {fieldHasContent(title) && (
              <Title>
                <PrismicRichText field={title} />
              </Title>
            )}
            {fieldHasContent(description) && (
              <Description>
                <PrismicRichText field={description} />
              </Description>
            )}
          </ContentWrapper>
          <div>
            {illustration && (
              <ImageWrapper>
                <Image
                  src={illustration?.url}
                  alt={illustration?.alt || ''}
                  width={illustration?.dimensions.width}
                  height={illustration?.dimensions.height}
                  quality="100"
                />
              </ImageWrapper>
            )}
          </div>
        </Wrapper>
      </ContentContainer>
    </Section>
  );
}
